// extracted by mini-css-extract-plugin
export var addButton = "_5b-d";
export var bullets = "_5b-e";
export var compact = "_5b-2";
export var container = "_5b-j";
export var extendedWarrantyModal = "_5b-f";
export var learn = "_5b-l";
export var learnMore = "_5b-g";
export var offeringOption = "_5b-3";
export var offeringPrice = "_5b-8";
export var offeringSubtitle = "_5b-7";
export var offeringTitle = "_5b-6";
export var offeringsContainer = "_5b-0";
export var pdpTilesBackground = "_5b-n";
export var plan = "_5b-m";
export var regular = "_5b-1";
export var remove = "_5b-k";
export var seeDetailsIcon = "_5b-i";
export var seeDetailsLink = "_5b-h";
export var selectedOption = "_5b-4";
export var shieldIcon = "_5b-b";
export var shieldIconCompact = "_5b-c";
export var subtitle = "_5b-a";
export var title = "_5b-9";
export var unselectedOption = "_5b-5";